/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A plus icon, to add files.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function PlusIcon({ size = 'medium', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      viewBox="0 0 40 39"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M20 .975c.552 0 1 .395 1 .882v16.668h17.095c.464 0 .847.376.899.861L39 19.5c0 .538-.405.975-.905.975H21v16.668c0 .452-.386.825-.883.876l-.117.006c-.552 0-1-.395-1-.882V20.475H1.905c-.464 0-.847-.376-.899-.861L1 19.5c0-.538.405-.975.905-.975H19V1.857c0-.452.386-.825.883-.876z"
      ></path>
    </svg>
  );
}
